const sectionWrapper = document.getElementById("section-wrapper");

// data from attributes
const clear_cart = sectionWrapper.dataset.clearCart === "true";
const product_id = sectionWrapper.dataset.productId;
const product_price = sectionWrapper.dataset.price;
const placeholder_color_name = sectionWrapper.dataset.placeholderColorName;
let build_a_box_data = null;

document.addEventListener("DOMContentLoaded", () => {
  // KEENSLIDER FOR PRODUCT IMAGES
  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
        });
      }

      function addActive(idx) {
        slider.slides[idx].classList.add("active");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx);
          });
        });
      }

      const leftButton = document.getElementById("keen-large-slider-left");
      const rightButton = document.getElementById("keen-large-slider-right");

      rightButton.addEventListener("click", () => {
        if (!slider.track.details.atEnd) {
          main.next();
        }
      });

      leftButton.addEventListener("click", () => {
        if (!slider.track.details.atStart) {
          main.prev();
        }
      });

      slider.on("created", () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
        });
      });
    };
  }

  const product_large_slider = new KeenSlider("#product-keen-large-slider", {
    loop: false,
    slides: {
      spacing: 0,
      perView: 1,
    },
  });

  const product_thumbnails_slider = new KeenSlider(
    "#product-keen-thumbnail-slider",
    {
      loop: false,
      slides: {
        spacing: 10,
        perView: 6,
      },
      vertical: false,
      created: () => {
        const slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
        slides.forEach((slide) => {
          slide.classList.remove("hidden");
        });
      },
    },
    [ThumbnailPlugin(product_large_slider)]
  );

  // GUARANTEE POPUP BLOCK
  const guarantee_popup_open_button = document.getElementById("block-guarantee-popup-open-button");
  const guarantee_popup_wrapper = document.getElementById("block-guarantee-popup-wrapper");
  const guarantee_popup_close_button = document.getElementById("block-guarantee-popup-close-button");

  if (guarantee_popup_open_button && guarantee_popup_wrapper) {
    guarantee_popup_open_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.remove("hidden");
    });
  }

  if (guarantee_popup_close_button && guarantee_popup_wrapper) {
    guarantee_popup_close_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.add("hidden");
    });
  }

  // CLEAR CART BEFORE PAGE LOAD
  if (clear_cart) {
    fetch("/cart.js", { cache: "no-store" })
      .then((res) => res.json())
      .then((cart) => {
        if (!cart.items || cart.items.length === 0) {
          return;
        }

        const updates = {};

        cart.items.forEach((item) => {
          updates[item.key] = 0;
        });

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      })
      .catch((err) => console.error("Error:", err));
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById("two-video-block-button-1");
  const two_video_block_button_2 = document.getElementById("two-video-block-button-2");
  const two_video_block_video_1 = document.getElementById("two-video-block-video-1");
  const two_video_block_video_2 = document.getElementById("two-video-block-video-2");

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener("click", () => {
      two_video_block_video_1.classList.remove("hidden");
      two_video_block_video_2.classList.add("hidden");
      two_video_block_button_1.style.borderBottom = "thin solid #211912";
      two_video_block_button_2.style.borderBottom = "none";
    });

    two_video_block_button_2.addEventListener("click", () => {
      two_video_block_video_1.classList.add("hidden");
      two_video_block_video_2.classList.remove("hidden");
      two_video_block_button_1.style.borderBottom = "none";
      two_video_block_button_2.style.borderBottom = "thin solid #211912";
    });
  }

  fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productPlatformId: product_id }),
  })
    .then((response) => response.json())
    .then((data) => {
      build_a_box_data = data;
      //console.log('Build a box data ----------------------', build_a_box_data);

      // NAIL PICKER INITIAL DATA
      const selectable_product_variants = build_a_box_data.DynamicBox.selectableProductVariants;
      const productIds = selectable_product_variants.map((p) =>
        p.productPlatformId.replace("gid://shopify/Product/", "")
      );

      // hide products from collection that are not in the build a box (in productIds array)
      // and set filters array for color and category
      const color_items_from_collection = document.querySelectorAll(".nail-picker-color");
      const colorSet = new Set();
      const categorySet = new Set();
      color_items_from_collection.forEach((item) => {
        const product_id = item.dataset.id;

        if (!productIds.includes(product_id)) {
          item.remove();
        } else {
          const colors = item.dataset.colorFilter;
          const categories = item.dataset.categoryFilter;

          if (colors) {
            colors.split(',').forEach(color => {
              colorSet.add(color.trim());
            });
          }
        
          if (categories) {
            categories.split(',').forEach(category => {
              categorySet.add(category.trim());
            });
          }
        }
      });
      const filterColorArray = Array.from(colorSet);
      const filterCategoryArray = Array.from(categorySet);

      // OPEN / CLOSE NAIL PICKER
      const pick_your_colors_button = document.getElementById("pick-your-colors-button");
      const pick_your_colors_button_price = pick_your_colors_button.querySelector(".price");
      const pick_your_colors_button_compare_price = pick_your_colors_button.querySelector(".compare-price");
      const upsells_wrapper = document.getElementById("upsells-wrapper");

      const variant_picker_items_element = document.getElementById("variant-picker-items");
      const pre_selected_variant_number = parseInt(variant_picker_items_element.dataset.preSelectedVariantNumber);

      // VARIANT PICKER
      const variant_picker_items = document.querySelectorAll(".variant-picker-item");
      let selected_number_of_wraps = 0;
      
      const build_a_box_id = build_a_box_data.DynamicBox.boxId;
      const selling_plans_data = build_a_box_data.DynamicBox.sellingPlanGroup;

      const selling_plans_ids = Object.entries(selling_plans_data)
        .sort(([, a], [, b]) => a.position - b.position)
        .map(([key, value]) => ({
          id: key.split("/").pop(),
          discount: value.priceAdjustmentAmount,
          interval: value.interval,
          interval_count: value.intervalCount,
        }));

      let selected_selling_plan_id = selling_plans_ids[pre_selected_variant_number - 1].id;

      const build_a_box_gift_items = document.querySelectorAll(".build-a-box-gift-item");
      const color_items = document.querySelectorAll(".nail-picker-color");

      // ADD COLOR ITEM BUTTONS
      const subscription_percent_element = document.getElementById("subscription-percent");
      const subscription_wraps_number_element = document.getElementById("subscription-wraps-number");
      const subscription_term_element = document.getElementById("subscription-term");
      const subscription_price_per_wrap_element = document.getElementById("subscription-price-per-wrap");
      const subscription_picker_first_item = document.querySelector(".subscription-picker-first-item");

      let selected_colors_array = [];

      const price_per_wrap_elements = document.querySelectorAll(".price-per-wrap");
      const variant_price_elements = document.querySelectorAll(".variant-price");
      const discount_percentage_elements = document.querySelectorAll(".discount-percentage");
      const price_block_loader_element = document.querySelector(".price-block-loader");
      const price_block_content_elements = document.querySelectorAll(".price-block-content");
      const price_block_elements = document.querySelectorAll(".price-block");    

      const nail_picker_selected_colors = document.querySelectorAll(".nail-picker-selected-color");

      const nail_picker_color_list_wrapper = document.getElementById("nail-picker-color-list-wrapper");

      const selected_colors_inside_picker = document.querySelectorAll('.selected-colors-inside-picker'); 
      const selected_colors_last_step = document.querySelectorAll('.selected-colors-last-step');

      const selected_colors_count_on_picker = document.querySelector('.selected-colors-count');
      const max_colors_number_on_picker = document.querySelector('.max-colors-number');

      const nail_picker_last_step_popup = document.getElementById('nail-picker-last-step-popup');

      const remove_selected_color_items = document.querySelectorAll('.remove-selected-color-item');
      const remove_selected_colors = document.querySelectorAll('.remove-selected-color');
      const remove_selected_colors_on_picker = document.querySelectorAll('.remove-selected-color-on-picker');
      const remove_selected_colors_on_last_step = document.querySelectorAll('.remove-selected-color-on-last-step');

      const upsells_selected_gifts = document.getElementById('upsells-selected-gifts');

      const upsells_collection_1 = document.getElementById('upsells-collection-1');
      const upsells_collection_2 = document.getElementById('upsells-collection-2');
      const upsells_collection_3 = document.getElementById('upsells-collection-3');
      
      // return free count from variant title
      function getFreeCount(str) {
        const match = str.match(/\+\s*(\d+)/);
        return match ? Number(match[1]) : null;
      }

      // return selected color count by data id
      function checkSelectedColor(data_id) {
        let selected_count = 0;
    
        for (const color of nail_picker_selected_colors) {
          const color_id = color.dataset.id;
    
          if (color_id === data_id) {
            selected_count++;
          }
        }
    
        return selected_count;
      }

      // get selected gifts count
      function getSelectedGiftsCount() {
        let selected_gifts = 0;

        build_a_box_gift_items.forEach((gift_item) => {
          const gift_item_image = gift_item.querySelector('img');
          if (!gift_item_image.classList.contains('hidden')) {
            selected_gifts++;
          }
        });

        return selected_gifts;
      }    

      const variants_upgrade_data = {};
      
      variant_picker_items.forEach((item, i, arr) => {
        const number_of_wraps = parseInt(item.dataset.numberOfWraps);
        const subscription_percent = selling_plans_ids[i].discount;

        // GET UPGRADE TEXT FOR VARIANT
        const upgrade_text = item.dataset.upgradeText || 'No upgrade text';
        if (number_of_wraps && upgrade_text) {
          variants_upgrade_data[number_of_wraps] = upgrade_text;
        }        

        // set the price for each variant
        const per_set_price =
          Math.round(((product_price - (product_price * subscription_percent) / 100) / 100) * 100) / 100;

        price_per_wrap_elements[i].textContent = per_set_price;
        variant_price_elements[i].textContent = (per_set_price * number_of_wraps).toFixed(2);
        discount_percentage_elements[i].textContent = subscription_percent;

        // add event listener to the variant picker item
        item.addEventListener("click", (event) => {
          const current_item = event.currentTarget;        
          const variant_title = current_item.dataset.title;

          // set selected number of wraps
          selected_number_of_wraps = number_of_wraps;

          // update subscription percent, wraps number, term and price per wrap
          subscription_percent_element.textContent = subscription_percent;
          subscription_wraps_number_element.textContent = selected_number_of_wraps;        
          subscription_price_per_wrap_element.textContent = per_set_price;

          const interval_count = selling_plans_ids[i].interval_count;
          if (interval_count > 1) {
            subscription_term_element.textContent = `${interval_count} ${selling_plans_ids[i].interval}s`;
          } else {
            subscription_term_element.textContent = `${interval_count} ${selling_plans_ids[i].interval}`;
          }

          selected_selling_plan_id = selling_plans_ids[i].id;

          // set upsells collection for each variant
          if (i === 0) {
            upsells_collection_1.style.display = 'flex';
            upsells_collection_2.style.display = 'none';
            upsells_collection_3.style.display = 'none';
          }
          if (i === 1) {
            upsells_collection_1.style.display = 'none';
            upsells_collection_2.style.display = 'flex';
            upsells_collection_3.style.display = 'none';
          }
          if (i === 2) {
            upsells_collection_1.style.display = 'none';
            upsells_collection_2.style.display = 'none';
            upsells_collection_3.style.display = 'flex';
          }          

          // remove active from all and set active class to selected variant
          arr.forEach((item, i) => {
            item.classList.remove("active");
          });
          current_item.classList.add("active");

          // hide all and show current price block
          price_block_elements.forEach((element) => {
            element.style.display = "none";
          });
          price_block_elements[i].style.display = "block"; 

          // get free count from free badges
          const freeCount = getFreeCount(variant_title);
          
          // update selected colors
          nail_picker_selected_colors.forEach((color, idx) => {
            const image = color.querySelector("img");
            const plus_icon = color.querySelector("span");
            const lock_icon = color.querySelector(".lock-icon");
            const remove_button = color.querySelector(".remove-selected-color");
            const color_name = color.querySelector("p");
            const isSelected = color.dataset.selected;
            const image_wrapper = color.firstElementChild;
    
            // ADD FREE LABEL TO MAIN SELECTED COLOR
            const free_label = color.querySelector('.nail-picker-selected-color-free-label');
            if (freeCount && idx <= selected_number_of_wraps - 1 && idx >= selected_number_of_wraps - freeCount) {
              free_label.style.display = 'block';
            } else {
              free_label.style.display = 'none';
            }    
    
            // RESTORE PLUS ICON AND REMOVE LOCK ICON FOR SELECTED COLORS
            if (!isSelected || isSelected === "false") {
              image.style.opacity = "1";
              plus_icon.style.display = "block";
              lock_icon.style.display = "none";
    
              const current_selected_color_inside_picker = selected_colors_inside_picker[idx];
              if (current_selected_color_inside_picker) {
                const plus_icon = current_selected_color_inside_picker.querySelector('span');
                if (plus_icon) {
                  plus_icon.style.display = "block";
                }
    
                const lock_icon = current_selected_color_inside_picker.querySelector('.lock-icon');
                if (lock_icon) {
                  lock_icon.style.display = "none";
                }
              }
            }
    
            // CLEAR DATA FROM SELECTED COLOR IF COLORS MORE THAN SELECTED VARIANT
            if (idx > selected_number_of_wraps - 1) {
              color.removeAttribute("data-selected");
              color.removeAttribute("data-id");
    
              image.removeAttribute('src');
              image.classList.add('hidden');
              color_name.textContent = `${placeholder_color_name} ${idx + 1}`;          
    
              plus_icon.style.display = "none";
              lock_icon.style.display = "block";
              remove_button.style.display = "none";
    
              image_wrapper.style.backgroundColor = "#FAF7F5";
              image_wrapper.style.borderColor = "#2119124D";
    
              const current_selected_colors_color_list = selected_colors_inside_picker[idx];
              if (current_selected_colors_color_list) {
                const img = current_selected_colors_color_list.querySelector('img');
                if (img) {
                  img.removeAttribute('src');
                  img.classList.add('hidden');
                }
    
                const plus_icon = current_selected_colors_color_list.querySelector('span');
                if (plus_icon) {
                  plus_icon.style.display = "none";
                }
    
                const lock_icon = current_selected_colors_color_list.querySelector('.lock-icon');
                if (lock_icon) {
                  lock_icon.style.display = "block";
                }
    
                const remove_button = current_selected_colors_color_list.querySelector('.remove-selected-color-on-picker');
                if (remove_button) {
                  remove_button.classList.add('hidden');
                }
    
                current_selected_colors_color_list.style.backgroundColor = "#FAF7F5";
                current_selected_colors_color_list.style.borderColor = "#2119124D";
              }
    
              const current_selected_colors_last_step = selected_colors_last_step[idx];
              if (current_selected_colors_last_step) {
                const img = current_selected_colors_last_step.querySelector('img');
                if (img) {
                  img.removeAttribute('src');
                  img.classList.add('hidden');
                }
    
                const lock_icon = current_selected_colors_last_step.querySelector('.lock-icon');
                if (lock_icon) {
                  lock_icon.classList.remove('hidden');
                }
    
                const remove_button = current_selected_colors_last_step.querySelector('.remove-selected-color-on-last-step');
                if (remove_button) {
                  remove_button.classList.add('hidden');
                }
    
                const upgrade_button = current_selected_colors_last_step.querySelector('.selected-last-step-upgrade');
                if (upgrade_button) {
                  upgrade_button.classList.remove('hidden');
                }
    
                current_selected_colors_last_step.style.cursor = "pointer";
              }
            } else {
              image_wrapper.style.backgroundColor = "#ffffff";
              image_wrapper.style.borderColor = "#211912B2";
    
              const current_selected_colors_color_list = selected_colors_inside_picker[idx];
              if (current_selected_colors_color_list) {
                current_selected_colors_color_list.style.backgroundColor = "#ffffff";
                current_selected_colors_color_list.style.borderColor = "#211912B2";
              }
    
              const current_selected_colors_last_step = selected_colors_last_step[idx];
              if (current_selected_colors_last_step) {
                current_selected_colors_last_step.style.cursor = "default";
              }
            }
          });        

          // add free label to selected colors inside picker
          selected_colors_inside_picker.forEach((color, idx) => {
            const free_label = color.querySelector('.selected-color-free-label-inside-picker');
            if (freeCount && idx <= selected_number_of_wraps - 1 && idx >= selected_number_of_wraps - freeCount) {
              free_label.style.display = 'block';
            } else {
              free_label.style.display = 'none';
            }
          });        

          // update color item list with new selected colors
          color_items.forEach(color_item => {
            const add_color_item_button = color_item.querySelector('.add-color-item-button');
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');

            const color_id = color_item.dataset.variantId;
            const color_count = checkSelectedColor(color_id);
            const color_item_count = color_item.querySelector('.color-item-count');

            if (color_count > 0) {
              if (color_item_count) {
                color_item_count.textContent = color_count;
                quantity_color_item_wrapper.classList.remove('hidden');
                add_color_item_button.classList.add('hidden');
              }
            } else {
              if (color_item_count) {
                color_item_count.textContent = 0;
                quantity_color_item_wrapper.classList.add('hidden');
                add_color_item_button.classList.remove('hidden');
              }
            }
          });

          // set max selected colors number on picker - 0 of X selected
          if (max_colors_number_on_picker) {
            max_colors_number_on_picker.textContent = selected_number_of_wraps;
          }

          // show/hide gift for selected variant
          build_a_box_gift_items.forEach((gift_item) => {
            const variant_name = parseInt(gift_item.dataset.variantName); // number of wraps for gift item
            const image = gift_item.querySelector("img");

            if (variant_name > selected_number_of_wraps) {
              image.classList.add("hidden");
            } else {
              image.classList.remove("hidden");
            }
          });

          upsells_selected_gifts.textContent = getSelectedGiftsCount();

          // update pick your colors button price and compare price
          pick_your_colors_button_price.textContent = (per_set_price * selected_number_of_wraps).toFixed(2);
          pick_your_colors_button_compare_price.textContent = ((product_price * selected_number_of_wraps) / 100).toFixed(2);
          
          // update selected colors array
          selected_colors_array = [];
          nail_picker_selected_colors.forEach(color => {
            const isSelected = color.dataset.selected;
            const id = color.dataset.id;

            if (isSelected && id) {
              selected_colors_array.push(id);
            }
          });

          markFirstEmptyPlace();
        });
      });

      // hide price block loader and show price block content
      price_block_loader_element.classList.add("hidden");
      price_block_content_elements.forEach((element) => {
        element.classList.remove("hidden");
        element.classList.add("flex");
      });

      // set pre selected variant by pre selected variant number
      variant_picker_items[pre_selected_variant_number - 1].click();
      subscription_picker_first_item.classList.remove("opacity-0"); // remove subscription opacity-0 after get data

      // SET UPGRADE TEXT FOR LAST STEP POPUP AND ADD CLICK EVENTS
      selected_colors_last_step.forEach((color, index) => {
        const data_keys = Object.keys(variants_upgrade_data);

        if (data_keys.length >= 2) {
          if (index >= data_keys[0] && index < data_keys[1] ) {
            color.querySelector(".selected-last-step-upgrade").textContent = variants_upgrade_data[data_keys[0]];
          }
          
          if (index >= data_keys[1]) {
            color.querySelector(".selected-last-step-upgrade").textContent = variants_upgrade_data[data_keys[1]];
          }

          color.addEventListener("click", () => {
            const upgrade_button = color.querySelector(".selected-last-step-upgrade");
            const button_text = upgrade_button.textContent;

            if (button_text.includes(variants_upgrade_data[data_keys[0]]) && !upgrade_button.classList.contains("hidden")) {
              variant_picker_items[1].click();
              nail_picker_last_step_popup.classList.add('hidden');
            }

            if (button_text.includes(variants_upgrade_data[data_keys[1]]) && !upgrade_button.classList.contains("hidden")) {
              variant_picker_items[0].click();
              nail_picker_last_step_popup.classList.add('hidden');
            }
          });
        }
      });

      const scroll_container = document.querySelector(".nail-picker-horizontal-scrollbar-2px");
      function markFirstEmptyPlace() {
        let isMarked = false;

        for (let i = 0; i < selected_colors_inside_picker.length; i++) {
          const color = selected_colors_inside_picker[i];
          const img_element = color.querySelector("img");
          color.classList.remove("first-empty-selected-color");
          
          if (i < selected_number_of_wraps) {
            if (!img_element.src && !isMarked) {
              color.classList.add("first-empty-selected-color");

              isMarked = true;

              color.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });
            }
          }
        }

        if (!isMarked && scroll_container) {
          scroll_container.scrollBy({
            left: -100,
            behavior: 'smooth'
          });
        }
      }

      // RUN SCROLL TO FIRST COLOR ITEM WHEN OPEN NAIL PICKER
      let is_reset_scroll = false;
      function runScroll() {
        if (is_reset_scroll) {
          is_reset_scroll = false;
          
          //scroll_container.scrollLeft = 0;
          
          const color_list_slider_wrapper = document.querySelector('.color-list-slider-wrapper');
          color_list_slider_wrapper.scrollTop = 0;
        }

        setTimeout(() => {
          const first_color_item = color_items[0];
          const image_wrapper = first_color_item.querySelector(".nail-picker-color-image-wrapper");
          image_wrapper.scrollTo({ left: 180, behavior: 'smooth' });
      
          setTimeout(() => {
            image_wrapper.scrollTo({ left: 0, behavior: 'smooth' });
          }, 1000);
        }, 1000);
      }
      
      // OPEN NAIL PICKER FROM SELECTED COLORS
      nail_picker_selected_colors.forEach((color) => {
        color.addEventListener("click", () => {
          document.body.style.overflow = "hidden";
          nail_picker_color_list_wrapper.classList.remove("hidden");

          const count = getSelectedCount(); 

          if (count === selected_number_of_wraps) {
            nail_picker_last_step_popup.classList.remove('hidden');
          } else {
            runScroll();
            markFirstEmptyPlace();
          }          
        });
      });

      // CLOSE NAIL PICKER BY CLOSE BUTTON
      const nail_picker_color_list_close_popup = document.querySelectorAll(".nail-picker-color-list-close-popup");
      nail_picker_color_list_close_popup.forEach((item) => {
        item.addEventListener("click", () => {
          document.body.style.overflow = "auto";
          nail_picker_color_list_wrapper.classList.add("hidden");
        });
      });

      // OPEN NAIL PICKER FROM PICK YOUR COLORS BUTTON
      if (pick_your_colors_button) {
        pick_your_colors_button.addEventListener("click", () => {
          document.body.style.overflow = "hidden";
          nail_picker_color_list_wrapper.classList.remove("hidden");

          const count = getSelectedCount(); 

          if (count === selected_number_of_wraps) {
            nail_picker_last_step_popup.classList.remove('hidden');
          } else {
            runScroll();
            markFirstEmptyPlace();
          }
        });

        pick_your_colors_button.querySelector(".loader").classList.add("hidden");
        pick_your_colors_button.querySelector(".text").classList.remove("hidden");
      }

      // NAIL PICKER COLOR SCROLL THUMB
      document.querySelectorAll('.nail-picker-color').forEach(card => {
        const content = card.querySelector('.scroll-content');
        const thumb = card.querySelector('.fake-thumb');
        const bar = thumb.parentElement;
      
        if (!content || !thumb) return;
      
        function updateThumb() {
          const maxScroll = content.scrollWidth - content.clientWidth;
      
          const ratio = content.scrollLeft / maxScroll;
          const maxX = bar.clientWidth - thumb.offsetWidth;
      
          thumb.style.transform = `translateX(${ratio * maxX}px)`;
        }
      
        content.addEventListener('scroll', updateThumb);
        window.addEventListener('resize', updateThumb);
      
        updateThumb();
      });

      // NAIL PICKER FILTER
      const nail_picker_filter_open_button = document.getElementById("nail-picker-filter-button");
      const filter_wrapper = document.getElementById("filter-wrapper");
      const nail_picker_shevrons_close_filter = document.getElementById("nail-picker-shevrons-close-filter"); 
      const nail_picker_shevrons_open_filter = document.getElementById("nail-picker-shevrons-open-filter"); 
      nail_picker_filter_open_button.addEventListener("click", () => {
        filter_wrapper.classList.toggle("hidden");

        if (filter_wrapper.classList.contains("hidden")) {
          nail_picker_shevrons_close_filter.classList.remove("hidden");
          nail_picker_shevrons_open_filter.classList.add("hidden");
          nail_picker_filter_open_button.classList.remove("nail-picker-filter-button-active");
        } else {
          nail_picker_shevrons_close_filter.classList.add("hidden");
          nail_picker_shevrons_open_filter.classList.remove("hidden");
          nail_picker_filter_open_button.classList.add("nail-picker-filter-button-active");
        }
      });

      const selected_color_filter_values = [];
      const selected_category_filter_values = [];

      // COLOR FILTER
      const filter_buttons = document.querySelectorAll('.nail-picker-color-filter-item');
      filter_buttons.forEach(item => {
        const values = item.dataset.value;
        const valuesArray = values.split(',');
        
        for (const value of valuesArray) {
          if (filterColorArray.includes(value)) {
            item.closest('li').classList.remove('hidden');

            item.addEventListener('click', (event) => {
              const current_color = event.currentTarget;
              const data_value = current_color.dataset.value;
        
              const remove_button = current_color.querySelector('.nail-picker-color-filter-item-remove');
        
              if (remove_button.classList.contains('hidden')) {
                selected_color_filter_values.push(data_value);
                remove_button.classList.remove('hidden');
                current_color.classList.add('border-[1.5px]');
                current_color.classList.add('border-[#000000]');
              } else {
                remove_button.classList.add('hidden');
                selected_color_filter_values.splice(selected_color_filter_values.indexOf(data_value), 1);
                current_color.classList.remove('border-[1.5px]');
                current_color.classList.remove('border-[#000000]'); 
              }
              
              setFilter();
            });

            break;
          }
        }    
      });

      // CATEGORY FILTER
      const category_filter_buttons = document.querySelectorAll('.nail-picker-category-filter-item');
      category_filter_buttons.forEach(item => {
        const values = item.dataset.value;
        const valuesArray = values.split(',');

        for (const value of valuesArray) {
          if (filterCategoryArray.includes(value)) {
            item.closest('li').classList.remove('hidden');

            item.addEventListener('click', (event) => {
              const current_category = event.currentTarget;
              const data_value = current_category.dataset.value;
        
              const remove_button = current_category.querySelector('.nail-picker-category-filter-item-remove');
        
              if (remove_button.classList.contains('hidden')) {
                selected_category_filter_values.push(data_value);
                remove_button.classList.remove('hidden');
                current_category.classList.add('nail-picker-category-filter-item-active');
              } else {
                remove_button.classList.add('hidden');
                selected_category_filter_values.splice(selected_category_filter_values.indexOf(data_value), 1);
                current_category.classList.remove('nail-picker-category-filter-item-active');
              }
              
              setFilter();
            });

            break;
          }
        }
      });
    
      // RUN FILTER FUNCTION
      function setFilter() {
        color_items.forEach((color_item) => {
          const data_color_filter = color_item.dataset.colorFilter;
          const data_category_filter = color_item.dataset.categoryFilter;
          let is_show = false;

          if (selected_category_filter_values.length > 0) {
            const color_category_values = data_category_filter.split(',');
            for (const color_category_value of color_category_values) {
              if (selected_category_filter_values.includes(color_category_value)) {
                is_show = true;
                break;
              } else {
                is_show = false;
              }
            }
          } else {
            is_show = true;
          }
          
          if (selected_color_filter_values.length > 0 && is_show) {
            const color_filter_values = data_color_filter.split(',');
            for (const color_filter_value of color_filter_values) {
              if (selected_color_filter_values.includes(color_filter_value)) {
                is_show = true;
                break;
              } else {
                is_show = false;
              }
            }
          }

          if (is_show) {
            color_item.classList.remove('hidden');
          } else {
            color_item.classList.add('hidden');
          }
        });
      }

      const nail_picker_color_open_popup = document.querySelectorAll('.nail-picker-color-open-popup');
      const nail_picker_color_close_popup = document.querySelectorAll('.nail-picker-color-close-popup');
      const nail_picker_color_popup_add_buttons = document.querySelectorAll('.nail-picker-color-popup-add-button');

      // slider init
      let slider = null;
      function sliderInit(elementId) {
        function sliderNavigation(slider) {
          let controlsWrapper, dots, arrowLeft, arrowRight;
        
          function removeElement(el) {
            el?.parentNode?.removeChild(el);
          }
        
          function createDiv(className) {
            const div = document.createElement("div");
            className.split(" ").forEach(name => div.classList.add(name));
            return div;
          }
        
          function controlsMarkup(remove) {
            if (remove) {
              removeElement(controlsWrapper);
              return;
            }
        
            controlsWrapper = createDiv("product-image-keen-slider-navigation-controls");
        
            arrowLeft = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--left");
            arrowRight = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--right");
        
            arrowLeft.innerHTML = " "; 
            arrowRight.innerHTML = " ";
        
            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight.addEventListener("click", () => slider.next());
        
            controlsWrapper.appendChild(arrowLeft);
            controlsWrapper.appendChild(arrowRight);
        
            dots = createDiv("product-image-keen-slider-dots");
            const totalSlides = slider.track.details.slides.length;
        
            for (let i = 0; i < totalSlides; i++) {
              const dot = createDiv("product-image-keen-slider-dot");
              dot.addEventListener("click", () => slider.moveToIdx(i));
              dots.appendChild(dot);
            }
        
            controlsWrapper.appendChild(dots);
            slider.container.parentNode.appendChild(controlsWrapper);
          }
        
          function updateClasses() {
            const rel = slider.track.details.rel;
        
            if (dots) {
              Array.from(dots.children).forEach((dot, idx) => {
                dot.classList.toggle("product-image-keen-slider-dot--active", idx === rel);
              });
            }
        
            if (arrowLeft && arrowRight) {
              const maxIdx = slider.track.details.slides.length - 1;
              arrowLeft.classList.toggle("disabled", rel === 0);
              arrowRight.classList.toggle("disabled", rel === maxIdx);
            }
          }
        
          slider.on("created", () => {
            controlsMarkup();
            updateClasses();
          });
        
          slider.on("slideChanged", updateClasses);
          slider.on("destroyed", () => controlsMarkup(true));
        }
        
        slider = new KeenSlider(
          elementId,
          {
            loop: false,
            slides: { perView: 1, spacing: 16 }
          },
          [sliderNavigation]
        );
      };

      // open nail picker color popup
      nail_picker_color_open_popup.forEach(item => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const data_popup_id = current_color.dataset.popupId;

          const color_popup = document.getElementById(data_popup_id);
          if (color_popup) {
            color_popup.classList.remove('hidden');
            nail_picker_color_list_wrapper.style.overflowY = 'hidden';

            const slider_container = color_popup.querySelector('.keen-slider');

            if (slider_container) {
              sliderInit(slider_container);
            }
          }      
        });
      });

      // close nail picker color popup
      nail_picker_color_close_popup.forEach(item => { 
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const data_id = current_color.dataset.id;      

          if (slider) {
            slider.destroy();
            slider = null;
          }

          const choose_color_popup = document.getElementById(data_id);
          if (choose_color_popup) {
            choose_color_popup.classList.add('hidden');
            nail_picker_color_list_wrapper.style.overflowY = 'auto';
          }
        });
      });

      // --- ADD COLORS TO PICKER --- //

      // get selected count
      function getSelectedCount() {
        let count = 0;
        nail_picker_selected_colors.forEach(color => {
          const isSelected = color.dataset.selected;
          if (isSelected) {
            count++;
          }
        });
        return count;
      }
      
      // add color function
      function addColor(id, image, image_line_item, title) {
        selected_colors_array.push(id);

        for (let loop_count = 0; loop_count < nail_picker_selected_colors.length; loop_count++) {
          const color = nail_picker_selected_colors[loop_count];
          const isSelected = color.dataset.selected;

          if (!isSelected) {
            const img = color.querySelector('img');
            img.setAttribute('src', image);
            img.classList.remove('hidden');       

            const color_name = color.querySelector('p');
            color_name.textContent = title;

            const plus_icon = color.querySelector('span');
            plus_icon.style.display = 'none';

            const remove_button = color.querySelector('.remove-selected-color');
            remove_button.style.display = 'block';
            
            color.dataset.selected = true;
            color.dataset.id = id;        

            const current_selected_color_inside_picker = selected_colors_inside_picker[loop_count];
            if (current_selected_color_inside_picker) {
              const img = current_selected_color_inside_picker.querySelector('img');
              if (img) {
                img.setAttribute('src', image);
                img.classList.remove('hidden');
              }

              const plus_icon = current_selected_color_inside_picker.querySelector('span');
              if (plus_icon) {
                plus_icon.style.display = "none";
              }

              const remove_button = current_selected_color_inside_picker.querySelector('.remove-selected-color-on-picker');
              if (remove_button) {
                remove_button.classList.remove('hidden');
              }

              current_selected_color_inside_picker.dataset.id = id;
            }

            const current_selected_color_last_step = selected_colors_last_step[loop_count];
            if (current_selected_color_last_step) {
              const img = current_selected_color_last_step.querySelector('img');
              if (img) {
                img.setAttribute('src', image);
                img.classList.remove('hidden');
              }

              const lock_icon = current_selected_color_last_step.querySelector('.lock-icon');
              if (lock_icon) {
                lock_icon.classList.add('hidden');
              }

              const swap_button = current_selected_color_last_step.querySelector('.remove-selected-color-on-last-step');
              if (swap_button) {
                swap_button.classList.remove('hidden');
              }

              const upgrade_button = current_selected_color_last_step.querySelector('.selected-last-step-upgrade');
              if (upgrade_button) {
                upgrade_button.classList.add('hidden');
              }

              current_selected_color_last_step.dataset.id = id;
            }

            break;
          }
        }

        const count = getSelectedCount();
        selected_colors_count_on_picker.textContent = count;    

        if (count === selected_number_of_wraps) {          
          nail_picker_last_step_popup.classList.remove('hidden');
        }

        markFirstEmptyPlace();
      }

      // add color to picker from color list
      color_items.forEach(color_item => {
        const add_color_item_button = color_item.querySelector('.add-color-item-button');
        const image_wrapper = color_item.querySelector('.nail-picker-color-image-wrapper');

        function tryAddColorFromItem() {
          const data_id = color_item.dataset.variantId;
          const data_title = color_item.dataset.title;
          const data_image = color_item.dataset.image;
          const data_image_line_item = color_item.dataset.imageLineItem;
          const current_selected_colors = getSelectedCount();

          if (current_selected_colors >= selected_number_of_wraps) return;

          if (add_color_item_button) {
            add_color_item_button.classList.add('hidden');
          } 

          const quantity_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
          if (quantity_wrapper) {
            quantity_wrapper.classList.remove('hidden');
          }

          addColor(data_id, data_image, data_image_line_item, data_title);

          const color_count = checkSelectedColor(data_id);
          const color_item_count = color_item.querySelector('.color-item-count');
          if (color_item_count) {
            color_item_count.textContent = color_count;
          }
        }

        if (add_color_item_button) {
          add_color_item_button.addEventListener('click', (event) => {
            tryAddColorFromItem();
          });
        }

        // click on image adds color like button (without triggering the slider scroll)
        if (image_wrapper) {
          let pointerDownX = 0;
          let pointerDownY = 0;

          image_wrapper.addEventListener('pointerdown', (e) => {
            pointerDownX = e.clientX;
            pointerDownY = e.clientY;
          }, { passive: true });

          image_wrapper.addEventListener('click', (e) => {
            const moveThreshold = 10;
            if (Math.abs(e.clientX - pointerDownX) > moveThreshold || Math.abs(e.clientY - pointerDownY) > moveThreshold) {
              return;
            }
            tryAddColorFromItem();
          });
        }

        const add_color_item_button_plus = color_item.querySelector('.color-item-count-plus');
        if (add_color_item_button_plus) {
          add_color_item_button_plus.addEventListener('click', () => {
            const current_color = color_item;
            const data_id = current_color.dataset.variantId;
            const data_title = current_color.dataset.title;
            const data_image = current_color.dataset.image;
            const data_image_line_item = current_color.dataset.imageLineItem;

            const current_selected_colors = getSelectedCount();

            if (current_selected_colors < selected_number_of_wraps) {
              addColor(data_id, data_image, data_image_line_item, data_title);
              
              const color_count = checkSelectedColor(data_id);
              const color_item_count = current_color.querySelector('.color-item-count');
              if (color_item_count) {
                color_item_count.textContent = color_count;
              }
            }
          });
        }
      });

      // add color to picker from color popup
      nail_picker_color_popup_add_buttons.forEach(item => {
        item.addEventListener('click', (event) => {
          const current_color = event.currentTarget;
          const data_id = current_color.dataset.id;
          const data_title = current_color.dataset.title;
          const data_image = current_color.dataset.image;
          const data_image_line_item = current_color.dataset.imageLineItem;
          const data_popup_id = current_color.dataset.popupId;

          const current_selected_colors_count = getSelectedCount();

          if (current_selected_colors_count < selected_number_of_wraps) {
            addColor(data_id, data_image, data_image_line_item, data_title);

            const color_item = document.querySelector(`.nail-picker-color[data-variant-id="${data_id}"]`);
            if (color_item) {
              color_item.querySelector('.add-color-item-button').classList.add('hidden');
              color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');

              const color_count = checkSelectedColor(data_id);
              const color_item_count = color_item.querySelector('.color-item-count');

              if (color_item_count) {
                color_item_count.textContent = color_count;
              }
            } else {
              console.warn('Color item not found for id:', data_id);
            }
          }
          
          const color_popup = document.getElementById(data_popup_id);
          color_popup.classList.add('hidden');

          if (slider) {
            slider.destroy();
            slider = null;
          }
        });
      });

      // --- REMOVE COLORS FROM PICKER --- //

      // remove buttons on color items
      remove_selected_color_items.forEach(item => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_item = event.currentTarget;
          const parent = current_item.closest('.nail-picker-color'); 
          const data_id = current_item.dataset.id;
          selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);

          let selected_index;
          nail_picker_selected_colors.forEach((color, index) => {
            if (color.dataset.id === data_id) {
              selected_index = index;
            }
          });

          // REMOVE FROM MAIN SELECTED COLORS LIST
          const current_selected_color = nail_picker_selected_colors[selected_index];
          if (current_selected_color) {
            const img = current_selected_color.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            current_selected_color.removeAttribute('data-selected');
            current_selected_color.removeAttribute('data-id');

            const color_name = current_selected_color.querySelector('p');
            color_name.textContent = `${placeholder_color_name} ${selected_index + 1}`;

            const plus_icon = current_selected_color.querySelector('span');
            plus_icon.style.display = 'block';

            const remove_button = current_selected_color.querySelector('.remove-selected-color');
            remove_button.style.display = 'none';
          }

          // REMOVE FROM INSIDE PICKER SELECTED COLORS LIST
          const current_selected_color_inside_picker = selected_colors_inside_picker[selected_index];
          if (current_selected_color_inside_picker) {
            const img = current_selected_color_inside_picker.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const icon_plus = current_selected_color_inside_picker.querySelector('span');
            if (icon_plus) {
              icon_plus.style.display = "block";
            }

            const remove_button = current_selected_color_inside_picker.querySelector('.remove-selected-color-on-picker');
            if (remove_button) {
              remove_button.classList.add('hidden');
            }
          }

          // REMOVE FROM COLOR ITEM LIST
          const color_item_count = parent.querySelector('.color-item-count');
          const color_count = checkSelectedColor(data_id);
          if (color_count > 0) {
            color_item_count.textContent = color_count;
            parent.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
            parent.querySelector('.add-color-item-button').classList.add('hidden');
          } else {
            color_item_count.textContent = 0;
            parent.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
            parent.querySelector('.add-color-item-button').classList.remove('hidden');
          }   

          selected_colors_count_on_picker.textContent = getSelectedCount();
          markFirstEmptyPlace();
        });
      });

      // remove buttons on selected colors
      remove_selected_colors.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const parent = current_color.parentElement;
          const color_id = parent.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(color_id), 1);

          const img = parent.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const color_name = parent.querySelector('p');
          color_name.textContent = `${placeholder_color_name} ${i + 1}`;

          const plus_icon = parent.querySelector('span');
          plus_icon.style.display = 'block';

          const remove_button = parent.querySelector('.remove-selected-color');
          remove_button.style.display = 'none';
          
          parent.removeAttribute('data-selected');
          parent.removeAttribute('data-id');

          const current_selected_colors_color_list = selected_colors_inside_picker[i];
          if (current_selected_colors_color_list) {
            const img = current_selected_colors_color_list.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const icon_plus = current_selected_colors_color_list.querySelector('span');
            if (icon_plus) {
              icon_plus.style.display = "block";
            }

            const remove_button = current_selected_colors_color_list.querySelector('.remove-selected-color-on-picker');
            if (remove_button) {
              remove_button.classList.add('hidden');
            }

            current_selected_colors_color_list.removeAttribute('data-id');
          }      

          // REMOVE FROM COLOR ITEM LIST
          const color_item = document.querySelector(`.nail-picker-color[data-variant-id="${color_id}"]`);
          if (color_item) {
            const color_item_count = color_item.querySelector('.color-item-count');
            const color_count = checkSelectedColor(color_id);

            if (color_count > 0) {        
              color_item_count.textContent = color_count;
              color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
              color_item.querySelector('.add-color-item-button').classList.add('hidden');
            } else {
              color_item_count.textContent = 0;
              color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
              color_item.querySelector('.add-color-item-button').classList.remove('hidden');
            }
          }

          selected_colors_count_on_picker.textContent = getSelectedCount();
          markFirstEmptyPlace();
        });
      });

      // remove buttons on selected colors on picker
      remove_selected_colors_on_picker.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_button = event.currentTarget;
          const parent = current_button.parentElement;
          const color_id = parent.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(color_id), 1);

          const img = parent.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const plus_icon = parent.querySelector('span');
          if (plus_icon) {
            plus_icon.style.display = "block";
          }

          const remove_button = parent.querySelector('.remove-selected-color-on-picker');
          if (remove_button) {
            remove_button.classList.add('hidden');
          }
          
          parent.removeAttribute('data-id');

          const current_selected_color = nail_picker_selected_colors[i];
          if (current_selected_color) {
            const img = current_selected_color.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            current_selected_color.removeAttribute('data-selected');
            current_selected_color.removeAttribute('data-id');

            const color_name = current_selected_color.querySelector('p');
            color_name.textContent = `${placeholder_color_name} ${i + 1}`;

            const plus_icon = current_selected_color.querySelector('span');
            plus_icon.style.display = 'block';

            const remove_button = current_selected_color.querySelector('.remove-selected-color');
            remove_button.style.display = 'none';
          }

          // REMOVE FROM COLOR ITEM LIST
          const color_item = document.querySelector(`.nail-picker-color[data-variant-id="${color_id}"]`);
          if (color_item) {
            const color_item_count = color_item.querySelector('.color-item-count');
            const color_count = checkSelectedColor(color_id);

            if (color_count > 0) {        
              color_item_count.textContent = color_count;
              color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
              color_item.querySelector('.add-color-item-button').classList.add('hidden');
            } else {
              color_item_count.textContent = 0;
              color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
              color_item.querySelector('.add-color-item-button').classList.remove('hidden');
            }
          }

          selected_colors_count_on_picker.textContent = getSelectedCount();
          markFirstEmptyPlace();
        });
      });

      // remove buttons on selected colors on last step
      remove_selected_colors_on_last_step.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_button = event.currentTarget;
          const parent = current_button.parentElement;
          const color_id = parent.dataset.id;      

          selected_colors_array.splice(selected_colors_array.indexOf(color_id), 1);

          const img = parent.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const lock_icon = parent.querySelector('.lock-icon');
          if (lock_icon) {
            lock_icon.classList.remove('hidden');
          }
          
          parent.removeAttribute('data-id');
          nail_picker_last_step_popup.classList.add('hidden');

          // REMOVE FROM MAIN SELECTED COLORS LIST
          const current_selected_color = nail_picker_selected_colors[i];
          if (current_selected_color) {
            const img = current_selected_color.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }        

            const color_name = current_selected_color.querySelector('p');
            color_name.textContent = `${placeholder_color_name} ${i + 1}`;

            const plus_icon = current_selected_color.querySelector('span');
            plus_icon.style.display = 'block';

            const remove_button = current_selected_color.querySelector('.remove-selected-color');
            remove_button.style.display = 'none';

            current_selected_color.removeAttribute('data-selected');
            current_selected_color.removeAttribute('data-id');
          }

          // REMOVE FROM INSIDE PICKER SELECTED COLORS LIST
          const current_selected_color_inside_picker = selected_colors_inside_picker[i];
          if (current_selected_color_inside_picker) {
            const img = current_selected_color_inside_picker.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const icon_plus = current_selected_color_inside_picker.querySelector('span');
            if (icon_plus) {
              icon_plus.style.display = "block";
            }

            const remove_button = current_selected_color_inside_picker.querySelector('.remove-selected-color-on-picker');
            if (remove_button) {
              remove_button.classList.add('hidden');
            }

            current_selected_color_inside_picker.removeAttribute('data-id');
          }
          
          // REMOVE FROM COLOR ITEM LIST
          const color_item = document.querySelector(`.nail-picker-color[data-variant-id="${color_id}"]`);
          if (color_item) {
            const color_item_count = color_item.querySelector('.color-item-count');
            const color_count = checkSelectedColor(color_id);

            if (color_count > 0) {        
              color_item_count.textContent = color_count;
              color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
              color_item.querySelector('.add-color-item-button').classList.add('hidden');
            } else {
              color_item_count.textContent = 0;
              color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
              color_item.querySelector('.add-color-item-button').classList.remove('hidden');
            }
          }

          selected_colors_count_on_picker.textContent = getSelectedCount();
          markFirstEmptyPlace();
        });
      });
      
      // LAST STEP POPUP CLOSE BUTTON
      const nail_picker_last_step_close_popup = document.querySelector(".nail-picker-last-step-close-popup");
      nail_picker_last_step_close_popup.addEventListener('click', () => {
        nail_picker_last_step_popup.classList.add('hidden');
        nail_picker_color_list_wrapper.classList.add("hidden");
        document.body.style.overflow = "auto";
      });

      // LAST STEP POPUP ADD TO CART BUTTON
      const nail_picker_last_step_atc_button = document.querySelector('.nail-picker-last-step-atc-button');
      nail_picker_last_step_atc_button.addEventListener('click', () => {
        goToUpsells();
      });

      // UPSSELLS OPEN / CLOSE BUTTONS
      const upsells_close_button = document.getElementById("upsells-close-button");
      const upsells_savings_amount = document.getElementById('upsells-savings-amount');

      let build_box_price = 0;
      let build_box_compare_price = 0;

      let upsells_products_prices = 0;
      let upsells_products_compare_prices = 0;

      const upsells_checkout_button = document.getElementById("upsells-checkout-button");
      const upsells_checkout_button_price = upsells_checkout_button.querySelector(".price");
      const upsells_checkout_button_compare_price = upsells_checkout_button.querySelector(".compare-price");

      const upsells_total_gifts = document.getElementById('upsells-total-gifts');
      upsells_total_gifts.textContent = build_a_box_gift_items.length.toString();

      let upsells_products_array = [];
      const upsells_add_buttons = document.querySelectorAll(".upsells-add-button");
      const upsells_quantity_buttons = document.querySelectorAll(".upsells-quantity-buttons");
      const remove_upsells_colors = document.querySelectorAll(".remove-upsells-color");
      const upsells_color_item_count_plus = document.querySelectorAll(".upsells-color-item-count-plus");

      function goToUpsells() {
        upsells_wrapper.classList.remove("hidden");

        upsells_products_array = [];
        upsells_products_prices = 0;
        upsells_products_compare_prices = 0;

        upsells_quantity_buttons.forEach((button) => {
          button.classList.add("hidden");
        });

        upsells_add_buttons.forEach((button) => {
          button.classList.remove("hidden");
        });

        let selected_selling_plan_discount;
        selling_plans_ids.forEach((plan) => {
          if (plan.id === selected_selling_plan_id) {
            selected_selling_plan_discount = plan.discount;
          }
        });

        const per_set_price = Math.round(
          ((product_price - (product_price * selected_selling_plan_discount) / 100) / 100) * 100
        );

        build_box_price = per_set_price * selected_colors_array.length;
        build_box_compare_price = parseFloat(product_price) * selected_colors_array.length;

        upsells_savings_amount.textContent = ((build_box_compare_price - build_box_price) / 100).toFixed(2);
        upsells_checkout_button_price.textContent = (build_box_price / 100 + upsells_products_prices / 100).toFixed(2);
        upsells_checkout_button_compare_price.textContent = (
          build_box_compare_price / 100 +
          upsells_products_compare_prices / 100
        ).toFixed(2);
      }

      upsells_close_button.addEventListener("click", () => {
        upsells_wrapper.classList.add("hidden");
      });

      // RATING REVIEWS COUNT
      /*function ratingReviewsCount() {
        const productRatings = document.querySelectorAll(".collection-product-rating");
        productRatings.forEach((rating) => {
          const html = rating.innerHTML;
          const reviews = html.split('data-number-of-reviews="')[1].split('"')[0];

          if (+reviews > 0) {
            rating.querySelector(".collection-product-rating-reviews-count").textContent = `(${reviews})`;
          }
        });
      }

      ratingReviewsCount();*/

      // UPSSELLS ADD BUTTON
      upsells_add_buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const data_variant_id = current_button.dataset.variantId;
          const data_price = parseInt(current_button.dataset.price);
          const data_compare_price = parseInt(current_button.dataset.comparePrice);

          upsells_products_array.push(data_variant_id);
          upsells_products_prices += data_price;
          upsells_products_compare_prices += data_compare_price;

          const total_price = build_box_price / 100 + upsells_products_prices / 100;
          const total_compare_price = build_box_compare_price / 100 + upsells_products_compare_prices / 100;
          
          upsells_checkout_button_price.textContent = total_price.toFixed(2);
          upsells_checkout_button_compare_price.textContent = total_compare_price.toFixed(2);
          upsells_savings_amount.textContent = (total_compare_price - total_price).toFixed(2);

          current_button.classList.add("hidden");
          const next_upsells_quantity_button = current_button.nextElementSibling;
          next_upsells_quantity_button.classList.remove("hidden");
          next_upsells_quantity_button.classList.add("flex");

          const quntity = next_upsells_quantity_button.querySelector(".upsells-color-item-count");
          quntity.textContent = 1;
        });
      });

      function getUpsellProductCount(data_variant_id) {
        return upsells_products_array.filter((id) => id === data_variant_id).length;
      }

      remove_upsells_colors.forEach((button) => {
        button.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const data_variant_id = current_button.dataset.variantId;
          const data_price = parseInt(current_button.dataset.price);
          const data_compare_price = parseInt(current_button.dataset.comparePrice);

          upsells_products_array.splice(upsells_products_array.indexOf(data_variant_id), 1);
          upsells_products_prices -= data_price;
          upsells_products_compare_prices -= data_compare_price;

          const total_price = build_box_price / 100 + upsells_products_prices / 100;
          const total_compare_price = build_box_compare_price / 100 + upsells_products_compare_prices / 100;
          
          upsells_checkout_button_price.textContent = total_price.toFixed(2);
          upsells_checkout_button_compare_price.textContent = total_compare_price.toFixed(2);
          upsells_savings_amount.textContent = (total_compare_price - total_price).toFixed(2);

          const quntity = getUpsellProductCount(data_variant_id);
          const quantity_element = current_button.nextElementSibling;
          quantity_element.textContent = quntity;

          if (quntity === 0) {
            const quantity_wrapper = current_button.parentElement;
            quantity_wrapper.classList.add("hidden");
            const next_upsells_quantity_button = quantity_wrapper.previousElementSibling;
            next_upsells_quantity_button.classList.remove("hidden");
            next_upsells_quantity_button.classList.add("flex");
          }
        });
      });

      upsells_color_item_count_plus.forEach((button) => {
        button.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const data_variant_id = current_button.dataset.variantId;
          const data_price = parseInt(current_button.dataset.price);
          const data_compare_price = parseInt(current_button.dataset.comparePrice);

          upsells_products_array.push(data_variant_id);
          upsells_products_prices += data_price;
          upsells_products_compare_prices += data_compare_price;

          const total_price = build_box_price / 100 + upsells_products_prices / 100;
          const total_compare_price = build_box_compare_price / 100 + upsells_products_compare_prices / 100;
          
          upsells_checkout_button_price.textContent = total_price.toFixed(2);
          upsells_checkout_button_compare_price.textContent = total_compare_price.toFixed(2);
          upsells_savings_amount.textContent = (total_compare_price - total_price).toFixed(2);

          const quntity = getUpsellProductCount(data_variant_id);
          const quantity_element = current_button.previousElementSibling;
          quantity_element.textContent = quntity;
        });
      });

      // PEDICURE UPSELLS OPEN BUTTON
      const open_pedicure_upsells_button = document.getElementById("open-pedicure-upsells-button");
      const pedicure_upsells_wrapper = document.getElementById("pedicure-upsells-wrapper");
      const pedicure_product_cards = document.querySelectorAll(".pedicure-product-card");

      open_pedicure_upsells_button.addEventListener("click", () => {
        pedicure_upsells_wrapper.classList.remove("hidden");

        const selected_colors_names = [];
        nail_picker_selected_colors.forEach((color) => {
          const is_selected = color.dataset.selected;
          if (is_selected) {
            const color_name = color.querySelector('p');
            selected_colors_names.push(color_name.textContent.trim());
          }
        });

        const unique_selected_colors_names = [...new Set(selected_colors_names)];

        pedicure_product_cards.forEach((card) => {
          const product_title = card.dataset.productTitle;
          card.classList.add("hidden");

          unique_selected_colors_names.forEach((name) => {
            if (product_title.includes(name)) {
              card.classList.remove("hidden");
            }
          });
        });
      });

      // PEDICURE UPSELLS CLOSE BUTTON
      const pedicure_upsells_close_buttons = document.querySelectorAll(".pedicure-upsells-close-button");
      pedicure_upsells_close_buttons.forEach((button) => {
        button.addEventListener("click", () => {
          pedicure_upsells_wrapper.classList.add("hidden");
        });
      });

      // UPSSELLS CHECKOUT BUTTON
      upsells_checkout_button.addEventListener("click", () => {
        const text = upsells_checkout_button.querySelector(".text");
        const loader = upsells_checkout_button.querySelector(".loader");
        const error_message = upsells_checkout_button.querySelector(".error-message");

        text.classList.add("hidden");
        loader.classList.remove("hidden");

        const gift_products_ids = [];
        build_a_box_gift_items.forEach((item, i) => {
          const img = item.querySelector("img");

          if (!img.classList.contains("hidden") && i !== 0) {
            const id = item.dataset.id;
            gift_products_ids.push(id);
          }
        });

        const productCount = {};

        selected_colors_array.forEach((id) => {
          if (productCount[id]) {
            productCount[id]++;
          } else {
            productCount[id] = 1;
          }
        });

        const payload = {
          items: [
            ...selected_colors_array.map((id, i) => ({
              id: id,
              quantity: 1,
              ...(selected_selling_plan_id && {
                selling_plan: selected_selling_plan_id,
              }),
              properties: {
                _dynamicBoxIndex: 0,
                _dynamicBoxId: build_a_box_id,
              },
            })),
            ...upsells_products_array.map((id) => ({
              id: id,
              quantity: 1,
              properties: {
                Upsell: "✓",
              },
            })),
            ...gift_products_ids.map((id) => ({
              id: id,
              quantity: 1,
              properties: {
                Gift: "✓",
              },
            })),
          ],
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("✅ Response from cart/add.js:", data);            

            if (data.items) {
              console.log("✅ Products added to cart");

              text.classList.remove("hidden");
              loader.classList.add("hidden");

              window.location.href = "/checkout";
            } else {
              console.log("❌ Products not added to cart");
              error_message.classList.remove("hidden");
              loader.classList.add("hidden");

              setTimeout(() => {
                error_message.classList.add("hidden");
                text.classList.remove("hidden");
              }, 5000);
            }
          })
          .catch((err) => console.error("❌ Error adding to cart:", err));
      });
    })
    .catch((error) => console.error("Error:", error));
});
